// Demo project list — what Maya would see when she opens the cockpit.
// In production this is fetched from the studio's tenant; here it is
// inline content data (not config — these are real Indian-residential
// project shapes for the pitch).

export type ProjectStatus = "active" | "draft" | "on-hold" | "delivered";

export interface ProjectSummary {
  id: string;
  name: string;
  city: string;
  client: string;
  client_email: string;   // typed — never synthesised in code
  bhk: string;
  budgetINR: number;
  deadline: string;       // ISO date
  alerts: number;
  status: ProjectStatus;
  thumbnailKey: string;   // resolves to a photo via imagery.ts
}

export const PROJECTS: ProjectSummary[] = [
  {
    id: "p1",
    name: "Riverside",
    client_email: "anika.r@gmail.com",
    city: "Hyderabad",
    client: "Anika & Rohan",
    bhk: "3BHK",
    budgetINR: 1_400_000,
    deadline: "2026-08-30",
    alerts: 2,
    status: "active",
    thumbnailKey: "livingSofa",
  },
  {
    id: "p2",
    name: "Bandra Penthouse",
    client_email: "verma.family@outlook.com",
    city: "Mumbai",
    client: "Verma family",
    bhk: "4BHK",
    budgetINR: 3_800_000,
    deadline: "2026-11-12",
    alerts: 4,
    status: "active",
    thumbnailKey: "diningWarm",
  },
  {
    id: "p3",
    name: "Indiranagar Loft",
    client_email: "mehta.work@gmail.com",
    city: "Bangalore",
    client: "Mehta · solo",
    bhk: "2BHK",
    budgetINR: 850_000,
    deadline: "2026-07-22",
    alerts: 1,
    status: "active",
    thumbnailKey: "workspace",
  },
  {
    id: "p4",
    name: "Hennur Villa",
    client_email: "krishnan.house@gmail.com",
    city: "Bangalore",
    client: "Krishnan · seniors",
    bhk: "5BHK",
    budgetINR: 6_200_000,
    deadline: "2027-02-28",
    alerts: 0,
    status: "draft",
    thumbnailKey: "bedroom",
  },
  {
    id: "p5",
    name: "Gulmohar Park",
    client_email: "ahuja.delhi@gmail.com",
    city: "Delhi",
    client: "Ahuja & sons",
    bhk: "3BHK",
    budgetINR: 2_100_000,
    deadline: "2026-09-18",
    alerts: 3,
    status: "on-hold",
    thumbnailKey: "kitchenIsland",
  },
  {
    id: "p6",
    name: "Marine Drive Studio",
    client_email: "sodhi.mum@icloud.com",
    city: "Mumbai",
    client: "Sodhi · pied-à-terre",
    bhk: "1BHK",
    budgetINR: 620_000,
    deadline: "2026-06-15",
    alerts: 0,
    status: "delivered",
    thumbnailKey: "moodboard",
  },
];

export const STATUS_LABEL: Record<ProjectStatus, string> = {
  active:    "Active",
  draft:     "Draft",
  "on-hold": "On hold",
  delivered: "Delivered",
};

export const STATUS_COLOR: Record<ProjectStatus, string> = {
  active:    "bg-fern/10 text-fern",
  draft:     "bg-cream-dark border border-border text-ink-700",
  "on-hold": "bg-foyr/10 text-foyr-deep",
  delivered: "bg-ink-950/5 text-ink-700",
};
